import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LanguageService } from 'src/app/services/language.service';
import { environment } from 'src/environments/environment';
import { DataForm } from 'src/app/models/data.model';
import { Accessory, Bike } from 'src/app/models/product.model';
import { Utils } from 'src/app/utils';
import { PAYMENT_WITH_WEBHOOKS } from 'src/app/app.constants';

enum EndpointRoutes {
  PLACE_ORDER = 'plugin/placeOrder',
  RETRY_CHECKOUT = 'plugin/retryCheckout',
  CONFIRM_PAYMENT_STATUS = 'plugin/confirmPaymentStatus',
  CONFIRM_ORDER = 'api/confirmOrder',
  DOWNLOAD_PDF = 'api/downloadPdf',
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private http = inject(HttpClient);
  private languageService = inject(LanguageService);

  public retryCheckout(contractId: string) {
    return this.http.post(environment.serverUrl + EndpointRoutes.RETRY_CHECKOUT, {
      contractId: contractId
    });
  }

  public placeOrder(d: DataForm) {
    const formData = {
      firstName: d.renterName,
      address: d.address,
      email: d.email,
      phone: `${d.dialCode?.dial_code || ''}${d.phone}`,
      to: Utils.toServerDateFormat(d.to),
      from: Utils.toServerDateFormat(d.from),
      startRental: d.startRental?.accountId,
      endRental: d.endRental?.accountId,
      comment: d.comment,
      price: d.discountedPrice?.toFixed(2) || 0,
      totalPrice: d.price?.toFixed(2) || 0,
      costForBikes: d.differentRentalPointsPrice,
      daysDiff: d.durationInDays,
      marketingUsage: d.marketing,
      discountCard: d.discountCard?.id,
      reservation: d.isReservation
    };

    const isDifferent = formData.startRental !== formData.endRental;

    const productSelected: any = [];
    d.accessories?.forEach((a: Accessory) => {
      productSelected.push({
        diffRentalCost: isDifferent ? a.bikeCost : 0,
        bikeType: a.bikeType,
        quantity: a.quantity,
        height: 0,
        price: a.bikePrice,
        bikePrice: a.bikePrice,
        singleBikeCost: a.bikeCost
      });
    });

    d.bikes?.forEach((b: Bike) => {
      productSelected.push({
        bikeType: b.bikeType,
        quantity: 1,
        price: b.bikePrice,
        bikePrice: b.bikePrice,
        diffRentalCost: isDifferent ? b.bikeCost : 0,
        height: b.height,
        accessories: b.accessories
      });
    });

    const params = {
      language: this.languageService.currentLanguage(),
      productSelected: productSelected,
      formData: formData,
      invoice: {
        ...d.invoice,
        country: d.invoice?.country?.name,
        countryCode: d.invoice?.country?.code,
      }
    };

    // return throwError(() => new Error('Simulated HTTP error response')); // for testing purposes
    return this.http.post(environment.serverUrl + EndpointRoutes.PLACE_ORDER, params);
  }

  public confirmPaymentStatus(ndc: string, contractId: string) {
    // return throwError(() => new Error('Simulated HTTP error response')); // for testing purposes
    const url = PAYMENT_WITH_WEBHOOKS ? EndpointRoutes.CONFIRM_PAYMENT_STATUS : EndpointRoutes.CONFIRM_ORDER;
    return this.http.get(environment.serverUrl + url, { params: { checkoutId: ndc, contractId: contractId}});
  }

  public generateReservationDownloadLink(contractId: string): string {
    return environment.serverUrl + EndpointRoutes.DOWNLOAD_PDF + '/reservation/' + contractId;
  }

}
